export default __webpack_public_path__ + "static/pict2Placeholder-4e5c19b57b5a64755829097f535ea6bc.png";